import React from 'react';
import ReactHtmlParser from 'react-html-parser'
import {cl,globs,constant} from '../../components/utils/utils';

class C18Confirm00 extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.popupRef=React.createRef()
    this.previousFocus=null
    this.previousFocusId=null
    this.modalOpen=false
    this.state={
      mounted:false,
      opacity:0,
      fading:false,
      showPopup:true,
    }
  }
  
  componentDidMount=()=>{
    this.mounted=true
    this.syncModalFocus(this.props.parms.opacity!==0)
  }

  componentDidUpdate=(prevProps,prevState)=>{
    let isOpen=this.props.parms.opacity!==0
    if(this.modalOpen!==isOpen){
      this.syncModalFocus(isOpen)
    }else if(isOpen&&prevState.opacity===0&&this.state.opacity!==0){
      this.focusFirstButton()
    }
  }
  
  componentWillUnmount=()=>{
    this.mounted=false
    document.removeEventListener("keydown",this.handleModalKeyDown)
  }

  syncModalFocus=(isOpen)=>{
    if(isOpen&&!this.modalOpen){
      this.modalOpen=true
      this.previousFocus=document.activeElement
      this.previousFocusId=this.previousFocus&&this.previousFocus.id
      document.addEventListener("keydown",this.handleModalKeyDown)
      if(this.state.opacity!==0){this.focusFirstButton()}
    }else if(!isOpen&&this.modalOpen){
      this.modalOpen=false
      document.removeEventListener("keydown",this.handleModalKeyDown)
      let menuFocus=sessionStorage.getItem("mainNavFocus")
      if(menuFocus!=="header-alarm-button"){
        let focusTarget=this.previousFocus&&document.contains(this.previousFocus)
          ?this.previousFocus
          :(this.previousFocusId&&document.getElementById(this.previousFocusId))
        if(focusTarget){setTimeout(()=>focusTarget.focus(),0)}
      }
      this.previousFocus=null
      this.previousFocusId=null
    }
  }

  focusFirstButton=()=>{
    let button=this.popupRef.current&&this.popupRef.current.querySelector("button:not(:disabled)")
    if(button){button.focus()}
  }

  handleModalKeyDown=(e)=>{
    if(!this.modalOpen||e.key!=="Tab"){return}
    let buttons=this.popupRef.current?.querySelectorAll("button:not(:disabled)")
    if(!buttons||!buttons.length){return}
    let first=buttons[0]
    let last=buttons[buttons.length-1]
    if(e.shiftKey&&(document.activeElement===first||!this.popupRef.current.contains(document.activeElement))){
      e.preventDefault()
      last.focus()
    }else if(!e.shiftKey&&(document.activeElement===last||!this.popupRef.current.contains(document.activeElement))){
      e.preventDefault()
      first.focus()
    }
  }
  
  mySetState=(state)=>{
    if(this.mounted){this.setState(state)}
  }
  
  onChange=(type,vals)=>{
    switch(type){
      case "popup":
        let r=this.props.parms.resolve
        if(r)(r(vals.cmd))
        break
    }
  }
  
  doFading=()=>{
    let step=0.01
    let diff=this.props.parms.opacity-this.state.opacity
    if (Math.abs(diff)<step){
      this.mySetState({fading:false, opacity:this.props.parms.opacity})
    }else{
      let op=this.state.opacity//+(diff>0)?step:(0-step)
      if(diff>0){
        op+=step
      }else{
        op-=step
      }
//       cl(this.props.parms.opacity,this.state.opacity,op)
      this.mySetState({opacity:op})
      setTimeout(this.doFading,80)
    }
  }
  
  render(){
//     cl("render confirm")
//     cl(this.props.parms)
    let diff=this.props.parms.opacity-this.state.opacity
    if(diff){setTimeout(this.doFading,1)}
    var ch
    if(Array.isArray(this.props.parms.text)){
      ch=<p>{this.props.parms.text}</p>
    }else{
      ch=<div>{this.props.parms.text.split('\n').map( (it, i) => <div key={'x'+i}>{it}</div> )}</div>
    }
//       ch=this.props.parms.text
//     cl(ch)
    return(
      <>
        <div id="popup" className="popup" role="dialog"
          aria-modal={this.props.parms.opacity!==0}
          aria-hidden={this.props.parms.opacity===0}
          ref={this.popupRef} style={{
          opacity: this.state.opacity,
          display:(this.state.opacity!=0)?"block":"none"}}>
          {ch}
          <br />
          <div className="alignright">
          {this.props.parms.buttons.map((b,i)=>{
            let filled=(["Yes","OK","Save"].includes(b))?"filled ":"outlined"
            return(
            <button id="popupButton" key={i} type="button" className={`${filled} left-margin`}
              onClick={e=>this.onChange("popup",{cmd:b})}
            >{b}</button> 
            )
          })}
          </div>
        </div>
        <div className="popup-scrim"></div>
      </>
    )
  }
}
      
export default C18Confirm00;
